import {post, get} from "./index.js";

async function getAccountSession(type = "onboarding") {
    try {
        return await post(`/payment/stripeConnect/session/${type}`);
    } catch (e) {
        throw e;
    }
}

async function finishAccountOnboarding() {
    try {
        return await post(`/payment/stripeConnect/finish`);
    } catch (e) {
        throw e;
    }
}

async function getPayouts(params) {
    try {
        return await get(`/landlord/payouts`, params);
    } catch (e) {
        throw e;
    }
}

async function getPayoutTransactions(payout_id) {
    try {
        return await get(`/landlord/payoutInfo/${payout_id}`);
    } catch (e) {
        throw e;
    }
}

export const stripeServices = {
    getAccountSession,
    finishAccountOnboarding,
    getPayouts,
    getPayoutTransactions
}
